var _defs, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#262626;}.cls-2{fill:#324242;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "autoPhoto") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 300,
    height: 300
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M218.18,193.18a11.4,11.4,0,0,1-11.36,11.37H93.18a11.39,11.39,0,0,1-11.36-11.37V106.81A11.39,11.39,0,0,1,93.18,95.45H206.82a11.39,11.39,0,0,1,11.36,11.36Zm-125-88.64a2.34,2.34,0,0,0-2.27,2.27v86.37a2.33,2.33,0,0,0,2.27,2.27H206.82a2.34,2.34,0,0,0,2.28-2.27V106.81a2.35,2.35,0,0,0-2.28-2.27Zm20.46,36.37a13.64,13.64,0,1,1,13.63-13.64A13.64,13.64,0,0,1,113.64,140.91ZM200,186.37H100V172.73L122.73,150l11.36,11.36L170.45,125,200,154.55Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.dd9d75f7a3a26d78455c9b8aa496de5b.svg";
export { ForwardRef as ReactComponent };